import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import moment from 'moment';

import '../SubscriptionPreview/module.css';

class TrialPreview extends Component {
  renderTrialExpirationDate() {
    const { subscriptions } = this.props;

    const expirationDate =
      subscriptions[0] &&
      subscriptions[0].trialDates &&
      subscriptions[0].trialDates.trialEnds;

    if (subscriptions.length > 1) {
      return <Link to="/tenants">See Trial Expiry Dates</Link>;
    } else if (expirationDate) {
      return moment(expirationDate).format('YYYY-MM-DD');
    }

    return null;
  }

  render() {
    const { subscriptions, withLinks } = this.props;

    return (
      <div className="trial-subscription-preview">
        <div className="row">
          <div styleName="label-group" className="col-xs-6">
            <span>Subscriptions</span>
            <div>Trial: {subscriptions.length}</div>
          </div>
          <div styleName="label-group" className="col-xs-6">
            <span>Trial Expiration Date</span>
            <div style={{ whiteSpace: 'nowrap' }}>
              <div
                className="trial-expiration-date"
                style={{ display: 'inline-block' }}
              >
                {this.renderTrialExpirationDate()}
              </div>
            </div>
          </div>
        </div>
        {withLinks && (
          <div className="row">
            <div styleName="label-group" className="col-xs-6">
              <span>Want to upgrade?</span>
              <div>
                <a styleName="arrow-link" href="http://auth0.com/pricing">
                  See Pricing
                </a>
              </div>
            </div>
            <div styleName="label-group" className="col-xs-6">
              <span>Special requirements?</span>
              <div>
                <a styleName="arrow-link" href="mailto:sales@auth0.com">
                  Contact Sales
                </a>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

TrialPreview.propTypes = {
  subscriptions: PropTypes.array.isRequired,
  withLinks: PropTypes.bool
};

export default TrialPreview;
